import TableCell, { TableCellProps } from '@mui/material/TableCell';

interface props extends TableCellProps {
  width?: string | number;
  flex?: boolean;
}

const TableCellCustom = ({ width, flex, ...rest }: props) => {
  return (
    <TableCell
      style={{
        width: flex ? 'auto' : width,
        flex: flex ? 1 : 'unset',
        paddingTop: '6px',
        paddingBottom: '6px',
      }}
      {...rest}
    />
  );
};

export default TableCellCustom;
